'use client';
import { datadogRum } from '@datadog/browser-rum';
import type { SegmentAbstraction } from '@repo/platform-analytics/lib/Segment';
import { v4 as uuid } from 'uuid';
import type { BucketedEventParams } from '../types/absmartly';

export const logABSmartlyBucketingDecision = (
  params: BucketedEventParams,
  analytics: SegmentAbstraction,
) => {
  if (analytics) {
    params.exposureData.forEach(({ experimentKey, variationKey, unitType }) => {
      datadogRum.addFeatureFlagEvaluation(
        // The hyphen is not allowed according to DD documentation
        //  https://docs.datadoghq.com/real_user_monitoring/guide/setup-feature-flag-data-collection/?tab=browser#feature-flag-naming
        experimentKey?.replace('-', '_'),
        variationKey,
      );
      void analytics.track(
        'Absmartly Experiment Bucketing Decision',
        {
          ...(unitType === 'anonymous_id'
            ? {
                bucketing_id: params.anonymousId,
                bucketing_id_type: 'anonymous_id',
              }
            : {
                bucketing_id: params.deviceId,
                bucketing_id_type: 'device_id',
              }),
          additional_attributes: {
            decision_location: 'client',
          },
          deployable_name: 'cardfinder-v2',
          deployable_version: params.deployableVersion ?? '1.0.0',
          experiment_key: experimentKey,
          traditional_device_id: params.deviceId,
          user_agent: uuid(),
          user_attributes: {
            ...params.attributes,
          },
          variation_key: variationKey,
        },
        {
          context: {
            app: {
              name: 'cardfinder-v2',
              version: params.gitSha,
            },
          },
        },
      );
    });
  }
};
